import "./authInterceptor"; // Auto sign-out on invalid/expired JWT
import Bugsnag from "@bugsnag/js";
import React, { Component, Suspense } from "react";
import cookie from "react-cookies";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
// Full MDI icon set. The trimmed subset (materialdesignicons.subset.css)
// only baked in 127 glyphs and broke as soon as new pages introduced new
// icons - every page across the app uses different icons, so the subset
// is too fragile to maintain. The full set is ~200KB CSS + ~256KB woff2
// but is cached after the first hit and never silently loses icons again.
import "./assets/css/materialdesignicons.min.css";
import ScrollToTop from "./components/common/scrollToTop";
import ChunkErrorFallback from "./components/common/ChunkErrorFallback";
import FaqAgentChat from "./components/FaqAgentChat/FaqAgentChat";
import FloatingQuoteCTA from "./components/common/FloatingQuoteCTA";
import routes from "./routes";
// Import Scss
import "./theme.scss";
import util from "./util";

class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    if (error?.name === "ChunkLoadError") {
      window.location.reload();
      return;
    }
    this.props.onError?.();
  }
  render() {
    if (this.state.hasError) {
      return (
        <ChunkErrorFallback onReload={() => window.location.reload()} />
      );
    }
    return this.props.children;
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { routeError: false };
    this.handleRouteError = () => this.setState({ routeError: true });
  }

  render() {
    try {
      // Capture Google Ads click IDs (gclid, gbraid, wbraid) FIRST
      // These are critical for conversion tracking attribution
      util.captureGoogleClickIds();

      if (!cookie.load("source_"))
        cookie.save(
          "source_",
          window.location.href + " prev:" + document?.referrer,
          {
            path: "/",
            maxAge: 8640000,
            secure: true,
          }
        );
      // if ("geolocation" in window.navigator) {
      //   /* geolocation is available */
      //   window.navigator.geolocation.getCurrentPosition((position) => {
      //     cookie.save(
      //       "locationsource_",
      //       JSON.stringify(
      //         position?.coords?.latitude + "," + position?.coords?.longitude
      //       ),
      //       {
      //         path: "/",
      //         maxAge: 8640000,
      //         secure: true,
      //       }
      //     );
      //   });
      // } else {
      //   /* geolocation IS NOT available */
      // }
    } catch (e) {
      Bugsnag.notify(e);
    }

    return (
      <React.Fragment>
        <Router>
          <ScrollToTop />
          <div>
          <ChunkErrorBoundary onError={this.handleRouteError}>
          <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
          <Switch>
            {routes.map((route, idx) => (
              <Route
                path={route.path}
                component={route.component}
                key={idx}
                exact
              />
            ))}
          </Switch>
          </Suspense>
          </ChunkErrorBoundary>
          </div>
          {!this.state.routeError && (
            <>
              <FaqAgentChat />
              <FloatingQuoteCTA />
            </>
          )}
        </Router>
      </React.Fragment>
    );
  }
}

export default withRouter(App);
